import { Link } from 'react-router-dom';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import Contact from '../../home/components/Contact';
import WhatsAppDiagnostic from '../../home/components/WhatsAppDiagnostic';

export default function IsolationThermiqueFenetresLyon() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-red-600 via-orange-500 to-amber-500 pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-temp-cold-line text-white"></i>
              <span className="text-white text-sm font-medium">Guide Isolation 2025</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
              Isolation Thermique Fenêtres Lyon
            </h1>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Guide complet sur l'isolation thermique des fenêtres à Lyon. Économisez jusqu'à 30% sur votre facture de chauffage avec des fenêtres bien isolées.
            </p>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <article className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Isolation Thermique des Fenêtres à Lyon : Guide Complet
            </h2>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              À Lyon, où les hivers peuvent être rigoureux et les étés chauds, l'isolation thermique des fenêtres est cruciale pour votre confort et vos économies d'énergie. Les fenêtres représentent 10 à 15% des déperditions thermiques d'un logement. Bien les choisir et les entretenir peut vous faire économiser jusqu'à 30% sur votre facture de chauffage.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Comprendre les Coefficients d'Isolation
            </h3>
            
            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Le Coefficient Uw : Performance Globale
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Le coefficient Uw mesure la performance thermique globale de la fenêtre (vitrage + châssis). Plus il est bas, meilleure est l'isolation. À Lyon, visez un Uw inférieur à 1.3 W/m².K pour une isolation optimale. Les meilleures fenêtres atteignent 0.8 W/m².K.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Le Coefficient Ug : Performance du Vitrage
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Le coefficient Ug concerne uniquement le vitrage. Double vitrage standard : 1.1 W/m².K, double vitrage renforcé avec argon : 0.9 W/m².K, triple vitrage : 0.6 W/m².K. Pour Lyon, le double vitrage renforcé offre le meilleur rapport performance/prix.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Types de Vitrages Isolants
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Double vitrage 4/16/4 :</strong> Standard, bon rapport qualité-prix, Ug = 1.1 W/m².K</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Double vitrage à isolation renforcée (VIR) :</strong> Couche faiblement émissive + argon, Ug = 0.9 W/m².K</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Triple vitrage :</strong> Performance maximale, Ug = 0.6 W/m².K, idéal pour maisons passives</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Vitrage à contrôle solaire :</strong> Limite la chaleur en été, recommandé pour exposition sud</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Matériaux et Isolation
            </h3>
            
            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              PVC : Champion de l'Isolation
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Le PVC offre la meilleure isolation thermique grâce à ses chambres d'air intégrées. Coefficient Uw moyen : 1.2 W/m².K. Les profilés à 5 ou 6 chambres atteignent 0.9 W/m².K. C'est le choix idéal pour maximiser les économies d'énergie à Lyon.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Aluminium à Rupture de Pont Thermique
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              L'aluminium seul est conducteur, mais avec rupture de pont thermique (barrette isolante), il atteint de bonnes performances : Uw = 1.4 à 1.6 W/m².K. Idéal pour grandes baies vitrées nécessitant solidité et finesse.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Bois : Isolation Naturelle
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Le bois est naturellement isolant avec un Uw de 1.2 à 1.4 W/m².K. Excellent pour les immeubles anciens de Lyon. Nécessite un entretien régulier mais offre charme et performances thermiques.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Économies Réalisables à Lyon
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              En remplaçant des fenêtres simple vitrage par du double vitrage performant, vous pouvez économiser :
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Appartement 60m² :</strong> 200€ à 400€ par an sur le chauffage</span>
              </li>
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Maison 100m² :</strong> 400€ à 700€ par an d'économies</span>
              </li>
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Retour sur investissement :</strong> 8 à 12 ans selon les aides obtenues</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Améliorer l'Isolation de Fenêtres Existantes
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Si vous ne pouvez pas remplacer vos fenêtres immédiatement, plusieurs solutions existent :
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Remplacement des joints :</strong> 40€-90€, amélioration immédiate de l'étanchéité</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Survitrage :</strong> Ajout d'une vitre supplémentaire, 100€-200€ par fenêtre</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Film isolant :</strong> Solution temporaire, 20€-50€ par fenêtre</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Volets et rideaux thermiques :</strong> Réduction des déperditions nocturnes de 30%</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Aides Financières pour l'Isolation
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Plusieurs aides sont disponibles à Lyon pour financer vos travaux d'isolation :
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-gift-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>MaPrimeRénov' :</strong> Jusqu'à 100€ par fenêtre selon revenus</span>
              </li>
              <li className="flex items-start">
                <i className="ri-gift-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Certificats d'Économies d'Énergie (CEE) :</strong> Prime variable selon travaux</span>
              </li>
              <li className="flex items-start">
                <i className="ri-gift-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Éco-PTZ :</strong> Prêt à taux zéro jusqu'à 15 000€</span>
              </li>
              <li className="flex items-start">
                <i className="ri-gift-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>TVA réduite :</strong> 5.5% au lieu de 20% avec artisan RGE</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Conclusion
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              L'isolation thermique des fenêtres est un investissement rentable à Lyon. Privilégiez le double vitrage renforcé avec châssis PVC pour un rapport performance/prix optimal. N'oubliez pas de faire appel à un professionnel RGE pour bénéficier des aides financières et garantir une pose dans les règles de l'art.
            </p>
          </article>
        </div>
      </section>

      {/* WhatsApp Diagnostic */}
      <WhatsAppDiagnostic />

      {/* Contact */}
      <Contact />
      
      <Footer />
    </div>
  );
}
